import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { GridOffset } from "@insite/mobius/GridContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

export const blackBlueBtn = Object.assign(wishListCardStyles, {
    ...wishListCardStyles,
    wishListInfoGridItem: {
        width: [10, 11, 8, 9, 10],
        align: "middle",
    },
    sharingStatusGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            > span {
                > div {
                    padding-left: 5px;
                }
            }
        `,
    },
    sharingStatus: {
        privateTooltip: {
            cssOverrides: {
                tooltipContainer: css`
                    left: 50px;
                    &:after {
                        left: 35%;
                    }
                `,
            },
        },
    },
    actionGridItem: {
        width: [2, 1, 4, 3, 2],
        align: "middle",
        css: css`
            justify-content: flex-end;
            // justify-content: center;
            button[data-test-selector^="wishListAddToCartButton"] {
                margin-right: 10px;
            }
        `,
    },
    actionGridMediumHidden: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            align-self: center;
            button[data-test-selector^="wishListAddToCartButton"] {
                margin-bottom: 5px;
            }
        `,
    },
    actionAddToCartButton: {
        variant: "primary",
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            text-transform: uppercase;
            border-radius: 22px;
            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
            border: none;
            min-width: 120px;
            color: ${COLORS.white};
            & :hover {
                background: ${COLORS.secondaryBtn};
            }
            &:disabled {
                background: ${COLORS.disabled.base};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
            }
        `,
    },
    actionDeleteButton: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            margin-right: 0.5rem;
            text-transform: uppercase;
            border-radius: 22px;
            border: 1px solid ${COLORS.secondaryBtn};
            min-width: 120px;
            background: ${COLORS.white};
            color: ${COLORS.secondaryBtn};
            & :hover {
                background: ${COLORS.secondaryBg};
                border: 1px solid ${COLORS.secondaryBtn};
            }
            &:disabled {
                background: ${COLORS.disabled.base};
                color: ${COLORS.white};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
                border: 1px solid ${COLORS.disabled.base};
                color: ${COLORS.white};
            }
        `,
    },
    actionOverflowMenu: {
        cssOverrides: {
            wrapper: css`
                > button {
                    justify-content: flex-start;
                    width: 30px;
                    min-width: auto;
                }
            `,
        },
    },
    extendedInfoGridItem: {
        width: [12, 12, 7, 8, 8],
        align: "middle",
        css: css`
            ${GridOffset} {
                width: calc(100% + 5px) !important;
            }
        `,
    },
});
